/**
 * Global, non-cart theme behavior: scroll-reveal animations and the header's
 * sticky/transparent scroll transform. Kept separate from cart.js (which owns
 * the ajax cart) and wishlist.js (which owns saved-product state) so each file
 * has one job.
 */
(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    const targets = document.querySelectorAll('[data-animate]');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  }

  function initHeaderScroll() {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const solidAfter = 8;
    let ticking = false;

    function update() {
      header.classList.toggle('site-header--solid', window.scrollY > solidAfter);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollReveal();
      initHeaderScroll();
    });
  } else {
    initScrollReveal();
    initHeaderScroll();
  }
})();
